import * as React from 'react';
import * as styled from './styled';
import {Field, FieldProps} from 'formik';
import {IngredientObject} from 'api/ingredient/types';
import {Builder} from 'components/Builder';
import Row from 'components/Row';
import Column from 'components/Column';
import Input, {InputVariant} from 'components/Input';
import {IngredientBuilderProps} from './types';

/**
 * The component create or update an ingredient.
 * @param {IngredientBuilderProps} props
 * @return {React.ReactElement<IngredientBuilderProps>}
 * @constructor
 */
export default function IngredientBuilder(
    props: IngredientBuilderProps,
): React.ReactElement<IngredientBuilderProps> {
  const defaultValue: Partial<IngredientObject> = {
    energy: {
      fats: 0,
      proteins: 0,
      kcal: 0,
      ch: 0,
    },
  };

  return (
    <Builder<IngredientObject> {...props} defaultValue={defaultValue}>
      {{
        content: (
          <styled.Wrapper>
            <Row>
              <Column>
                <Field name="title">
                  {({field}: FieldProps) => (
                    <Input
                      {...field}
                      label="Название ингредиента"
                      placeholder="Введите название ингредиента"
                      required
                    />
                  )}
                </Field>
              </Column>
            </Row>
            <br/>
            <Row>
              <Column>
                <Field name="energy.kcal">
                  {({field}: FieldProps) => (
                    <Input
                      {...field}
                      type="number"
                      label="Калории (на 100 г)"
                      placeholder="Введите число"
                      min={0}
                      required
                    />
                  )}
                </Field>
              </Column>
              <Column>
                <Field name="energy.proteins">
                  {({field}: FieldProps) => (
                    <Input
                      {...field}
                      type="number"
                      label="Белки (на 100 г)"
                      placeholder="Введите число"
                      min={0}
                      required
                    />
                  )}
                </Field>
              </Column>
              <Column>
                <Field name="energy.fats">
                  {({field}: FieldProps) => (
                    <Input
                      {...field}
                      type="number"
                      label="Жиры (на 100 г)"
                      placeholder="Введите число"
                      min={0}
                      required
                    />
                  )}
                </Field>
              </Column>
              <Column>
                <Field name="energy.ch">
                  {({field}: FieldProps) => (
                    <Input
                      {...field}
                      type="number"
                      label="Углеводы (на 100 г)"
                      placeholder="Введите число"
                      min={0}
                      required
                    />
                  )}
                </Field>
              </Column>
            </Row>
          </styled.Wrapper>
        ),
        footer: (options) => (
          <Builder.Footer {...options} />
        ),
      }}
    </Builder>
  );
}
